import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { login } from "../redux/actions/user";
// import Sign from "../components/Sign";
import LoaderImg from "../auditor/favicon.svg";

const Login = (props) => {
    // const [ loading, setLoading ] = useState(false);
    // const navigate = useNavigate();
    // const dispatch = useDispatch();

    window.location.replace("/signin?from=auditor")

    // const handleLogin = async e => {
    //     setLoading(true);
    //     try {
    //         await axios
    //             .post(
    //                 "/auditor/business/account/login", 
    //                 {
    //                     email: e.email,
    //                     password: e.password
    //                 }
    //             );
    //         dispatch(login());
    //         navigate("/dashboard");
    //     } catch(error) {
    //         setLoading(false);
    //     }
    // }

    return (
        // <Sign 
        // // title="Login"
        // // subtitle="As an existing auditor"
        //     title="Auditor Login"
        //     type="login" 
        //     formComplete={handleLogin}
        //     errorMessage=""
        //     loading={loading}
        // />
        <div className="loader loading">
            <img src={LoaderImg} alt="loader" />
        </div>
    )
}

export default Login;